import { Button } from "@/src/components/ui/button";
import { useToast } from "@/src/components/ui/use-toast";
import { useEmit } from "@/src/lib/actions";
import { useFetch } from "@/src/lib/useFetch";

export const SyncRatesButton = () => {
  const emitSynced = useEmit("ratesSynced");
  const { toast } = useToast();
  const { fetch, isFetching } = useFetch();

  const onPress = async () => {
    try {
      await fetch(`/api/currencies/sync-request`, "POST");
      emitSynced();
      toast({
        title: "Rates synced",
        description: "The rates have been updated",
      });
    } catch (error: any) {
      const message = "message" in error ? error.message : "An error occurred";
      toast({
        title: "Failed to sync rates",
        description: message,
        variant: "destructive",
      });
    }
  };

  return (
    <Button disabled={isFetching} onClick={onPress}>
      Sync rates
    </Button>
  );
};
